import Vue from 'vue'
import CodeInput from 'vue-verification-code-input'

Vue.component('CodeInput', CodeInput)
